const firebaseConfig = {
    apiKey: "AIzaSyCfhOswgP55x-BNw8F46mU3lONzZwZViEI",
    authDomain: "mysk-hospital.firebaseapp.com",
    projectId: "mysk-hospital",
    storageBucket: "mysk-hospital.appspot.com",
    messagingSenderId: "1041247181732",
    appId: "1:1041247181732:web:27c1cbb0101daad2273f31"
};

export default firebaseConfig;